/* ============================================================================
   GLAME LAB PDP — deneysel ürün detay sayfası davranışları
   ============================================================================
   Yalnızca alternatif ürün şablonlarında yüklenir (templates/product.<handle>.json).
   Kapsam:
     · galeri (küçük görsel → büyük görsel, varyanta bağlı görsel)
     · varyant seçimi (fiyat, taksit, stok, sepet id'si, adres çubuğu)
     · adet seçici (tema ayarındaki sepet limitine kadar)
     · mobil sabit satın alma çubuğu
     · mod sekmeleri ve SSS akordeonu

   Sepete ekleme burada YOK: form [data-product-form] taşıdığı için
   assets/theme.js içindeki Cart modülü devralır, limit tek yerde uygulanır.
   Adet düğmeleri bilerek data-lp-* adlarını kullanıyor; data-quantity-*
   kullanılsa theme.js'teki iki genel dinleyici aynı tıklamayı ikinci kez
   sayardı.
   ============================================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-lp-root]');

  function money(cents) {
    if (window.GlameMoney && window.GlameMoney.tl) return window.GlameMoney.tl(cents);
    var whole = Math.round((cents || 0) / 100);
    return String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' TL';
  }

  function text(el, value) {
    if (el) el.textContent = value;
  }

  /* ── Galeri ─────────────────────────────────────────────────────────────── */
  function Gallery(scope) {
    var thumbs = Array.prototype.slice.call(scope.querySelectorAll('[data-lp-thumb]'));
    var slides = Array.prototype.slice.call(scope.querySelectorAll('[data-lp-slide]'));
    if (!slides.length) return null;

    function show(mediaId) {
      var found = false;
      slides.forEach(function (slide) {
        var active = String(slide.dataset.lpSlide) === String(mediaId);
        slide.classList.toggle('is-active', active);
        if (active) found = true;
        /* Başka görsele geçilince video sesli çalmaya devam etmesin */
        var video = slide.querySelector('video');
        if (video && !active && !video.paused) video.pause();
      });
      thumbs.forEach(function (thumb) {
        var active = String(thumb.dataset.lpThumb) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      return found;
    }

    function step(direction) {
      var index = slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
      if (index < 0) index = 0;
      var next = slides[(index + direction + slides.length) % slides.length];
      show(next.dataset.lpSlide);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb.dataset.lpThumb); });
    });

    /* Telefonda görseller parmakla kaydırılarak da değişir; küçük görsel
       şeridi dokunmatikte küçük bir hedef. */
    var frame = scope.querySelector('[data-lp-frame]');
    if (frame && slides.length > 1) {
      var startX = 0;
      var startY = 0;
      frame.addEventListener('touchstart', function (event) {
        startX = event.changedTouches[0].clientX;
        startY = event.changedTouches[0].clientY;
      }, { passive: true });
      frame.addEventListener('touchend', function (event) {
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        /* Yatay hareket dikeyden baskınsa kaydırma sayılır, sayfa kaydırması bozulmaz */
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    return { show: show, step: step };
  }

  /* ── Adet ───────────────────────────────────────────────────────────────── */
  function Quantity(scope) {
    var input = scope.querySelector('[data-lp-qty-input]');
    var output = scope.querySelector('[data-lp-qty-output]');
    var minus = scope.querySelector('[data-lp-qty-minus]');
    var plus = scope.querySelector('[data-lp-qty-plus]');
    if (!input || !minus || !plus) return;

    var max = parseInt(input.getAttribute('max'), 10);
    if (!(max > 0)) max = Infinity;

    function render() {
      var value = parseInt(input.value, 10) || 1;
      text(output, String(value));
      minus.disabled = value <= 1;
      plus.disabled = value >= max;
    }

    minus.addEventListener('click', function () {
      var value = parseInt(input.value, 10) || 1;
      if (value > 1) { input.value = value - 1; render(); }
    });

    plus.addEventListener('click', function () {
      var value = parseInt(input.value, 10) || 1;
      if (value < max) { input.value = value + 1; render(); }
    });

    render();
  }

  /* ── Varyant ────────────────────────────────────────────────────────────── */
  function Variants(scope, gallery) {
    var dataEl = scope.querySelector('[data-lp-data]');
    var swatches = scope.querySelectorAll('[data-lp-value]');
    if (!dataEl || !swatches.length) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    if (!variants.length) return;

    var selected = {};
    swatches.forEach(function (btn) {
      if (btn.classList.contains('is-active')) selected[btn.dataset.lpIndex] = btn.dataset.lpValue;
    });

    var stage = scope.querySelector('[data-lp-stage]');
    var idInput = scope.querySelector('[data-lp-variant-id]');
    var priceEl = scope.querySelector('[data-lp-price]');
    var compareEl = scope.querySelector('[data-lp-compare]');
    var offEl = scope.querySelector('[data-lp-off]');
    var instEl = scope.querySelector('[data-lp-installment]');
    var atc = scope.querySelector('[data-lp-atc]');
    var stock = scope.querySelector('[data-lp-stock]');
    var stockText = scope.querySelector('[data-lp-stock-text]');
    var optionLabels = scope.querySelectorAll('[data-lp-option-label]');

    function find() {
      return variants.filter(function (variant) {
        return (variant.options || []).every(function (value, index) {
          return !selected[index] || selected[index] === value;
        });
      })[0];
    }

    function apply(variant) {
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      text(priceEl, money(variant.price));
      text(instEl, money(Math.round(variant.price / 12)));

      if (compareEl) {
        var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !hasCompare;
        if (hasCompare) text(compareEl, money(variant.compare_at_price));
        if (offEl) {
          offEl.hidden = !hasCompare;
          if (hasCompare) {
            var off = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            text(offEl, '−%' + off);
          }
        }
      }

      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? (data.strings.add || 'SEPETE EKLE') : (data.strings.soldout || 'TÜKENDİ');
      }

      if (stock) {
        var qty = typeof variant.inventory === 'number' ? variant.inventory : null;
        var low = variant.available && qty !== null && qty > 0 && qty <= 5;
        stock.hidden = false;
        stock.classList.toggle('lp-stock--low', low);
        if (!variant.available) {
          text(stockText, data.strings.outofstock || 'Şu an stokta yok');
        } else if (low) {
          text(stockText, 'Son ' + qty + ' adet');
        } else {
          text(stockText, data.strings.instock || 'Stokta, aynı gün kargoya verilir');
        }
      }

      optionLabels.forEach(function (label) {
        var index = label.dataset.lpOptionLabel;
        if (selected[index]) text(label, selected[index]);
      });

      /* Varyantın kendi görseli varsa sahneye onu al */
      if (gallery && variant.media_id) gallery.show(variant.media_id);

      /* Mobil çubuk: fiyat ve seçili varyant adı */
      text(document.querySelector('[data-lp-sticky-price]'), money(variant.price));
      var stickyVariant = document.querySelector('[data-lp-sticky-variant]');
      if (stickyVariant) {
        var names = Object.keys(selected).map(function (key) { return selected[key]; });
        text(stickyVariant, names.join(' · '));
      }
      var stickyBtn = document.querySelector('[data-lp-sticky-btn]');
      if (stickyBtn) stickyBtn.disabled = !variant.available;

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* adres çubuğu güncellenemezse akış bozulmaz */ }
    }

    /* Sahnedeki ışık seçili renge döner: "#B76E79" → yumuşak bir hâlesi.
       Renk kodu tanınmazsa markanın kendi tonu kalır. */
    function glow(btn) {
      if (!stage) return;
      var dot = btn.querySelector('.lp-swatch__dot');
      var color = dot ? getComputedStyle(dot).backgroundColor : '';
      var parts = color.match(/\d+/g);
      if (!parts || parts.length < 3) return;
      stage.style.setProperty('--lp-glow', 'rgba(' + parts[0] + ',' + parts[1] + ',' + parts[2] + ',.24)');
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.dataset.lpIndex;
        scope.querySelectorAll('[data-lp-index="' + index + '"]').forEach(function (sibling) {
          sibling.classList.remove('is-active');
          sibling.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        selected[index] = btn.dataset.lpValue;
        glow(btn);
        apply(find());
      });
    });

    /* Açılışta da seçili rengin hâlesi uygulanır */
    var active = scope.querySelector('[data-lp-value].is-active');
    if (active) glow(active);
  }

  /* ── Mobil sabit çubuk ──────────────────────────────────────────────────── */
  function StickyBar(scope) {
    var bar = document.querySelector('[data-lp-sticky]');
    var atc = scope.querySelector('[data-lp-atc]');
    if (!bar || !atc) return;

    var trigger = bar.querySelector('[data-lp-sticky-btn]');
    if (trigger) trigger.addEventListener('click', function () { atc.click(); });

    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(atc);
  }

  /* ── Mod sekmeleri ──────────────────────────────────────────────────────── */
  function Modes() {
    document.querySelectorAll('[data-lp-modes]').forEach(function (wrap) {
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-lp-mode-tab]'));
      var panels = wrap.querySelectorAll('[data-lp-mode-panel]');
      if (!tabs.length) return;

      function select(id, focus) {
        tabs.forEach(function (tab) {
          var active = tab.dataset.lpModeTab === id;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (active && focus) tab.focus();
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.lpModePanel === id);
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { select(tab.dataset.lpModeTab); });
        tab.addEventListener('keydown', function (event) {
          var step = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1
            : event.key === 'ArrowUp' || event.key === 'ArrowLeft' ? -1 : 0;
          if (!step) return;
          event.preventDefault();
          var next = tabs[(index + step + tabs.length) % tabs.length];
          select(next.dataset.lpModeTab, true);
        });
      });
    });
  }

  /* ── SSS ────────────────────────────────────────────────────────────────── */
  function Faq() {
    document.querySelectorAll('[data-lp-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        /* Sınıf, açık satırın zemini için: :has desteklemeyen tarayıcılar da kapsanır */
        var item = btn.closest('.lp-faq__item');
        if (item) item.classList.toggle('is-open', !open);
      });
    });
  }

  /* ── Bölüm gezintisi ────────────────────────────────────────────────────── */
  function SectionNav() {
    var nav = document.querySelector('[data-lp-nav]');
    if (!nav) return;

    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-lp-nav-link]'));
    var targets = links.map(function (link) {
      return document.getElementById((link.getAttribute('href') || '').replace('#', ''));
    });
    var inner = nav.querySelector('.lp-nav__inner');

    /* Hedefi olmayan bağlantı (bölüm kaldırılmışsa) gösterilmez */
    links.forEach(function (link, index) {
      if (!targets[index]) link.hidden = true;
    });
    if (!targets.filter(Boolean).length) { nav.hidden = true; return; }

    function mark(index) {
      links.forEach(function (link, i) {
        var current = i === index;
        link.classList.toggle('is-current', current);
        if (current) {
          link.setAttribute('aria-current', 'true');
          /* Aktif bağlantı şeridin görünür kısmına çekilir */
          if (inner && inner.scrollWidth > inner.clientWidth) {
            var left = link.offsetLeft - (inner.clientWidth - link.offsetWidth) / 2;
            inner.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    /* Hangi bölümdeyiz: gezinti çubuğunun hemen altındaki noktaya bakılır */
    function spy() {
      var line = nav.getBoundingClientRect().bottom + 12;
      var current = -1;
      targets.forEach(function (target, index) {
        if (target && target.getBoundingClientRect().top <= line) current = index;
      });
      mark(current);
    }

    /* Yumuşak kaydırma: adres çubuğuna da çapa yazılır ki geri tuşu çalışsın */
    links.forEach(function (link, index) {
      link.addEventListener('click', function (event) {
        var target = targets[index];
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        try { window.history.replaceState({}, '', link.getAttribute('href')); } catch (e) { /* yoksay */ }
      });
    });

    /* Şerit yana kayabiliyorsa kenar geçişleri açılır; böylece telefonda
       görünmeyen bağlantıların varlığı belli olur. */
    function edges() {
      if (!inner) return;
      var hidden = inner.scrollWidth - inner.clientWidth;
      nav.classList.toggle('has-more-start', hidden > 4 && inner.scrollLeft > 4);
      nav.classList.toggle('has-more-end', hidden > 4 && inner.scrollLeft < hidden - 4);
    }

    if (inner) {
      var edgeWaiting = false;
      inner.addEventListener('scroll', function () {
        if (edgeWaiting) return;
        edgeWaiting = true;
        window.requestAnimationFrame(function () { edges(); edgeWaiting = false; });
      }, { passive: true });
      window.addEventListener('resize', edges);
      edges();
    }

    var waiting = false;
    window.addEventListener('scroll', function () {
      if (waiting) return;
      waiting = true;
      window.requestAnimationFrame(function () { spy(); waiting = false; });
    }, { passive: true });
    spy();
  }

  function init() {
    Modes();
    Faq();
    SectionNav();
    if (!root) return;
    var gallery = Gallery(root);
    Quantity(root);
    Variants(root, gallery);
    StickyBar(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
